// 注册通用的全局组件
// ==============================
import Vue from 'vue'
import Footer from '@/components/tw-footer'
import DocHeader from '@/components/tw-header'
import ToTop from '@/components/tw-totop'
const components = [
  Footer,
  ToTop,
  DocHeader
]

components.forEach(function (component) {
  Vue.component(component.name, component)
})

// 注册通用的全局指令
// ==============================
import Fix from '@/directives/fix'
import Bottom from '@/directives/bottom'

const directives = [
  Fix,
  Bottom
]
directives.forEach(function (directive) {
  Vue.directive(directive.name, directive)
})



// WEBPACK FOOTER //
// ./src/config/register.js